<template>
  <div>
  <div class="calendar">
    <div class="container">
      <div class="c-header">
        <ol>
          <li><el-date-picker @change="changeYear" v-model="year" type="year" placeholder="选择年" :clearable="false" > </el-date-picker></li>
          <li><i class="el-icon-arrow-left" @click="prevDate"></i><el-select @change="changeMonth" v-model="month" placeholder="请选择"><el-option v-for="item in monthOptions" :key="item" :label="item" :value="item"></el-option></el-select><i class="el-icon-arrow-right" @click="nextDate"></i></li>
        </ol>
        <div style="display:flex">
          <div class="button" @click="onBack">返回今天</div>
          <div class="button"><router-link to="/">返回首页</router-link></div>
        </div>
      </div>
      <div class="c-body">
        <el-calendar v-model="dataTime">
          <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
          <template slot="dateCell" slot-scope="{ date, data }">
            <div slot="reference" class="div-Calendar" @click="handleMonthChanged(data.day)">
              <span class="canlendar-n" :class="getWeek(data.day) === '六' || getWeek(data.day) === '日' ? 'mo' : ''">{{data.day.split('-')[2]}}</span>
              <span class="canlendar-g" v-if="!getOtherFestivalsText(data.day)">{{getGregorianCalendar(data.day)}}</span>
              <span class="canlendar-g red" v-else>{{getOtherFestivalsText(data.day)}}</span>
              <div class="xiu-box">
              <span class="xiu" v-if="getDaySanHui(data.day)"><i>{{ getDaySanHui(data.day) }}</i></span>
              <span class="xiu" v-if="getDaySanYuan(data.day)"><i>{{ getDaySanYuan(data.day) }}</i></span>
              <span class="xiu" v-if="getDayWuLa(data.day)"><i>{{ getDayWuLa(data.day) }}</i></span>
              <span class="xiu" v-if="getDayBaHui(data.day)"><i>{{ getDayBaHui(data.day) }}</i></span>
              <span class="xiu" v-if="getDayBaJie(data.day)"><i>{{ getDayBaJie(data.day) }}</i></span>
              <span class="xiu" v-if="getDayMingWu(data.day)"><i>{{ getDayMingWu(data.day) }}</i></span>
              <span class="xiu" v-if="getDayAnWu(data.day)"><i>{{ getDayAnWu(data.day) }}</i></span>
              <span class="xiu" v-if="getDayTianShe(data.day)"><i>{{ getDayTianShe(data.day) }}</i></span>
              </div>
            </div>
          </template>
        </el-calendar>
      </div>
      <div class="festival-baike">
        <p v-if="festivalBaike.length > 0"><i>纪念日</i><span v-for="(item, index) in festivalBaike" :key="index"><em :class="item.desc !== '' ? 'hover' : ''" @click="clickDrawer(item)">{{item.name}}</em></span></p>
      </div>
      <div class="c-trips">
          <span><i>道 历</i><br>{{getYearInChineseText()}}</span>
          <ul>
            <li><i v-for="(item, index) in dao" :key="index" @click="clickDrawer2(item)">{{item}}</i></li>
          </ul>
        </div>
    </div>
    </div>
    <footerCon></footerCon>
    <!--注释-->
    <el-drawer
      :title="drawerTitle"
      :visible.sync="drawerVisible"
      class="drawer-detail"
      direction="rtl"
      size= "40%"
      :before-close="handleClose">
      <div v-html="drawerHtml"></div>
    </el-drawer>
  </div>
</template>
<script>
import footerCon from "@/components/footer";
import calendar from '@/utils/calendar';
import {Solar, SolarWeek, Lunar, Foto, Tao} from 'lunar-typescript';
import c from '@/utils/c'
export default {
  components: {
    footerCon
  },
  data() {
    return {
      today: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      year: new Date().getFullYear().toString(),
      month: new Date().getMonth() + 1 + '月',
      day:'',
      monthOptions:['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
      disabled: false,
      dataTime: new Date(),
      festivalBaike:[],
      dao:['三会日','三元日','八节日','五腊日','八会日','戊日','天赦日'],
      c:c.data,
      drawerVisible:false,
      drawerTitle:'',
      drawerHtml:'',
      huiArr:[
        { name:'三会日', desc:'<p>正月七日，名：举迁赏会，此日上元赐福，天官同地水二官考校罪福。</p><p>七月七日，名：庆生中会，此日中元赦罪，地官同天水二官考校罪福。</p><p>十月十五日，名：建生大会，此日下元解厄，水官同天地二官考校罪福。</p><p>其三会之日，三官考核功过，三魂攒送生人善恶。又谓之三魂会日，宜焚香忏过。</p>'},
        { name:'三元日', desc:'<p>正月十五，上元节；七月十五，中元节，十月十五，下元节。</p><p>其三元之日，天地水三官二十七府百二十曹之神，先于三会日考校罪福，至三元日上奏金阙，以降祸福。其日可行道建斋，修身谢过。</p>'},
        { name:'八节日', desc:'<p>立春：东北方度仙上圣天尊同梵炁始青天君下降。</p><p>春分：东方玉宝星上天尊同青帝九炁天君下降。</p><p>立夏：东南方好生度命天尊同梵炁始丹天君下降。</p><p>夏至：南方玄真万福天尊同赤帝三炁天君下降。</p><p>立秋：西南方太灵虚皇天尊同梵炁始素天君下降。</p><p>秋分：西方太妙至极天尊同白帝七炁天君下降。</p><p>立冬：西北方无量太华天尊同梵炁始玄天君下降。</p><p>冬至：北方玄上玉宸天尊同黑帝五炁天君下降。</p><p>其曰八极天尊天君同下人问，录人罪福，观察善恶。</p>'},
        { name:'五腊日', desc:'<p>正月一日，名天腊，此日五帝会于东方九炁青天。</p><p>五月五日，名地腊，此日五帝会于南方三炁丹天。</p><p>七月七日，名道德腊，此日五帝会于西方七炁素天。</p><p>十月一日，名民岁腊，此日五帝会于北方五炁黑天。</p><p>十一月八日，名王侯腊，此日五帝会于上方玄都玉京。</p><p>其五帝攒会之日，此日酆都北阴天帝考校鬼魂，查生人祖考及见世子孙所行善恶，以定罪福。此日皆累生人，宜当醮谢，须凭法力祭祀，追赎涂苦，一一得福，常日祭祀，不可享也。</p>'},
        { name:'八会日', desc:'<p>天会丙午，地会壬午，人会壬子，日会庚午，月会庚申，星辰会辛酉，五行会甲辰，四时会甲戌。</p><p>其节会宜斋戒焚香，醮告星辰，看经拜忏，祭祀先灵，可以延年益算。</p>'},
        { name:'戊日',  desc:'<p>戊日为禁忌日，道场会在戊日休息。戊日又分为明戊日、暗戊日。</p><p>明戊日即天干为“戊”的日子。</p><p>暗戊日则按口诀推算：正羊（未日）二犬（戍日）三在辰，四月期间不犯寅，五午六子七鸡（酉日）位，八月周流又到申，九蛇（巳日）十猪（亥日）十一兔（卯日），十二牛头（丑日）重千斤。</p>'},
        { name:'天赦日', desc:'<p>天赦日，四时专气、生育万物、免罪赦过、天帝赦免众生罪过吉日，最利于消灾化煞，祈福延寿。天赦日最忌杀生，遇此日婚娶、宴请不要肆意杀生，尽量提前购买三净肉以备使用或者干脆素宴。</p>'}
      ]
    };
  },
  mounted(){
    this.initData()
  },
  methods: {
    //默认数据
    initData(){
      this.day =  new Date().getDate()
      this.dataTime = this.year + '-' + this.month.split('月')[0] + '-' + this.day
      this.today = this.dataTime
      this.methodAll()
    },
    //方法合集
    methodAll(){
      this.getYearInGanZhiText()
      this.getDayYiText();
      this.getDayJiText()
      this.getOtherFestivalsText2()
      // this.getTableData()
      // this.getTableData2()
      const now = new Date()
      let year = now.getFullYear()
      if(year < Number(this.year)){
        this.disabled = true
      }else{
        this.disabled = false
      }
    },
    //选择年份
    changeYear(e){
      this.year = new Date(e).getFullYear().toString()
      this.holiday = ''
      this.dataTime = new Date(e).getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
      this.today = this.dataTime
      this.methodAll()
    },
    //选择月份
    changeMonth(){
      this.holiday = ''
      this.initData()
    },
    //上一个月
    prevDate(){
      if(this.month === '1月'){
        this.year = (Number(this.year) - 1).toString()
        this.month = '12月'
      }else{
        this.month = Number(this.month.split('月')[0]) - 1 + '月'
      }
      this.holiday = ''
      this.initData()
    },
    //下一个月
    nextDate(){
      if(this.month === '12月'){
        this.year = (Number(this.year) + 1).toString()
        this.month = '1月'
      }else{
        this.month = Number(this.month.split('月')[0]) + 1 + '月'
      }
      this.holiday = ''
      this.initData()
    },
    //返回今天
    onBack(){
      this.year = new Date().getFullYear().toString()
      this.month = new Date().getMonth() + 1  + '月'
      this.initData()
      this.holiday = ''
    },
    //获取公历
    getGregorianCalendar(dateList){
      const d = Lunar.fromDate(new Date(dateList));
      return d.getDayInChinese()
    },
    //获取星期
    getWeek(dateList){
      var d = Lunar.fromDate(new Date(dateList));
      return d.getWeekInChinese()
    },
    //获取佛历时间
    getYearInChineseText(){
      const s = Solar.fromDate(new Date(this.today))
      const d = s.getLunar();
      const tao = d.getTao();
      return tao.getYear() + '年 ' 
    },
    //获取道历节日
    getOtherFestivalsText(dateList){
      var dao = Tao.fromLunar(Lunar.fromDate(new Date(dateList)));
      var lunar = dao.getLunar();
      let text = ''
      var d = Tao.fromLunar(Lunar.fromYmd(lunar._year, lunar._month, lunar._day));
      var l = d.getFestivals();
      for (var i=0, j=l.length; i<j; i++){
        text = l[i];
      }
      return text
    },
    getOtherFestivalsText2(){
      var dao = Tao.fromLunar(Lunar.fromDate(new Date(this.today)));
      var lunar = dao.getLunar();
      let text = []
      var d = Tao.fromLunar(Lunar.fromYmd(lunar._year, lunar._month, lunar._day));
      var l = d.getFestivals();
      for (var i=0, j=l.length; i<j; i++){
        text.push(l[i]._name)
      }
      this.festivalBaike = []
      let fs2 = []
      text.forEach(item=>{
        if(typeof item._name != 'undefined'){
          fs2.push(item._name)
        }else{
          fs2.push(item)
        }
      })
      for(let i=0; i<fs2.length; i++){
        for(let j=0; j<this.c.length; j++){
          if(fs2[i] === this.c[j].name && this.c[j].isHide === true){
            this.festivalBaike.push(this.c[j])
          }
        }
      }
    },
    //点击节日事件
    clickDrawer(item){
      // this.drawerTitle = item.name
      this.drawerHtml = item. desc
      if(this.drawerHtml !== ''){
        this.drawerVisible = true
      }
    },
    clickDrawer2(item){
      this.drawerTitle = item
      this.drawerHtml = this.huiArr.filter(items => items.name === item)[0].desc
      if(this.drawerHtml !== ''){
        this.drawerVisible = true
      }
    },
    handleClose(){
      this.drawerVisible = false
    },
    //三会日
    getDaySanHui(dateList){
      const d = Tao.fromLunar(Lunar.fromDate(new Date(dateList)));
      return d.isDaySanHui() === true ? '三会日' : ''
    },
    //三元日
    getDaySanYuan(dateList){
      const d = Tao.fromLunar(Lunar.fromDate(new Date(dateList)));
      return d.isDaySanYuan() === true ? '三元日' : ''
    },
    //观音斋
    getDayWuLa(dateList){
      const d = Tao.fromLunar(Lunar.fromDate(new Date(dateList)));
      return d.isDayWuLa() === true ? '五腊日' : ''
    },
    //八会日
    getDayBaHui(dateList){
      const d = Tao.fromLunar(Lunar.fromDate(new Date(dateList)));
      return d.isDayBaHui() === true ? '八会日' : ''
    },
    //八节日
    getDayBaJie(dateList){
      const d = Tao.fromLunar(Lunar.fromDate(new Date(dateList)));
      return d.isDayBaJie() === true ? '八节日' : ''
    },
    //戊日
    getDayWu(dateList){
      const d = Tao.fromLunar(Lunar.fromDate(new Date(dateList)));
      return d.isDayWu() === true ? '戊日' : ''
    },
    //明戊日
    getDayMingWu(dateList){
      const d = Tao.fromLunar(Lunar.fromDate(new Date(dateList)));
      return d.isDayMingWu() === true ? '明戊日' : ''
    },
    //暗戊日
    getDayAnWu(dateList){
      const d = Tao.fromLunar(Lunar.fromDate(new Date(dateList)));
      return d.isDayAnWu() === true ? '暗戊日' : ''
    },
    //天赦日
    getDayTianShe(dateList){
      const d = Tao.fromLunar(Lunar.fromDate(new Date(dateList)));
      return d.isDayTianShe() === true ? '天赦日' : ''
    },
    //27星宿
    getDayXinxiu1(){
      const d = Foto.fromLunar(Lunar.fromDate(new Date(this.today)));
      const g = d.getGong() + '方' + d.getXiu() + d.getZheng() + d.getAnimal() + ' (' + d.getXiuLuck() + ')'
      return g
    },
    //歌诀
    getDayXinxiu2(){
      const d = Foto.fromLunar(Lunar.fromDate(new Date(this.today)));
      const g = d.getXiuSong()
      return g
    },
    //获取天干
    getYearInGanZhiText(){
      const d = Lunar.fromDate(new Date(this.today));
      return d.getYearInGanZhi() + ' ' + d.getYearShengXiao()
    },
    //获取每日宜
    getDayYiText(){
      const d = Lunar.fromDate(new Date(this.today));
      let l = d.getDayYi();
      let arr = []
      for (let i=0, j=l.length; i<j; i++){
        arr.push(l[i])
      }
      return arr.toString()
    },
    //获取每日忌
    getDayJiText(){
      const d = Lunar.fromDate(new Date(this.today));
      let l = d.getDayJi();
      let arr = []
      for (let i=0, j=l.length; i<j; i++){
        arr.push(l[i])
      }
      return arr.toString()
    },
    //获取星期
    getIndexInYearText(){
      var d = SolarWeek.fromDate(new Date(this.today), 1);
      return d.getIndexInYear();
    },
    //获取星座
    getXingZuoText(){
      var d = Solar.fromDate(new Date(this.today));
      return d.getXingZuo()
    },
    //点击事件
    handleMonthChanged(dateList){
      this.holiday = ''
      this.year = dateList.split('-')[0]
      this.month = Number(dateList.split('-')[1]) + '月'
      this.day = Number(dateList.split('-')[2])
      this.today = this.year + '-' + this.month.split('月')[0] + '-' + this.day
      this.methodAll()
    },
  }
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "JingHuaLaoSongTi";
  font-weight: normal;
  src: url("../assets/aliyun/8m2D40dU62JY.woff2") format("woff2"),
  url("../assets/aliyun/8m2D40dU62JY.woff") format("woff");
  font-display: swap;
  font-style: normal;
}
.calendar * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.calendar {
  display: flex;
  justify-content: space-between;
  .container {
    width: 100%;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,.08);
    border-radius: 15px;
    margin: 0;
    box-sizing: border-box;
    // border: 2px solid #4E6EF2;
    overflow: hidden;
    .c-header {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 55px;
      padding: 12px;
      background: #eaecf2;
      overflow: hidden;
      ol{
        display: flex;
        align-items: center;
        li{
          display: flex;
          align-items: center;
          position: relative;
          margin-right: 10px;
          width: 240px;
          i{
            color: #888;
            font-size: 16px;
            cursor: pointer;
            margin: 0 3px;
            &:hover{
              color: #333;
            }
          }
        }
      }
      .button{
        width: 72px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #fff;
        border-radius: 6px;
        color: #333;
        cursor: pointer;
        font-size: 13px;
        margin-left: 12px;
        &:hover{
          color: #0f9fff;
          opacity: .75;
        }
      }
    }
    .c-body{
      width: 100%;
      overflow: hidden;
      .div-Calendar{
        position: relative;
        span{
          display: block;
          &.canlendar-n{
            margin-top: 8px;
            font-family: 'JingHuaLaoSongTi'; 
          }
          &.mo{
            color: #da5036;
          }
          &.canlendar-g{
            display: block;
            padding: 0 5px;
            font-size: 13px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &.canlendar-jq{
            display: block;
            padding: 0 5px;
            font-size: 13px;
            color: #23b255;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &.red{
            color: #da5036;
          }
           &.ban{
            position: absolute;
            top: -8px;
            right: 0;
            font-size: 12px;
            &::before{
              display: block;
              content: '';
              width: 0;
              height: 0;
              border-top: 24px solid #888;
              border-left: 24px solid transparent; 
            }
            i{
              position: absolute;
              right: 1px;
              top: 1px;
              z-index: 5;
              color: #fff;
              font-size: 10px;
            }
          }
        }
        .xiu-box{
            position: absolute;
            top: -8px;
            right: 0;
            .xiu, .xiu2{
              position: relative;
              width: 35px;
              height: 18px;
              line-height: 18px;
              text-align: center;
              background: #23b255;
              font-size: 12px;
              margin-bottom: 2px;
              border-radius: 3px 0 0 3px;
            i{
              position: absolute;
              right: 1px;
              top: 1px;
              width: 100%;
              z-index: 5;
              font-style: normal;
              color: #fff;
              font-size: 10px;
              box-sizing: border-box;
              padding-left: 2px;
            }
          }
          .xiu2{
            background: red;
          }
        }
      }
    }
  }
  .festival-baike{
      display: flex;
      background: rgba(245, 246, 249, .5);
      border-radius: 0.12rem;
      border-bottom: 1px solid #EBEEF5;
      color: #36f;
      overflow: hidden;
      p{
        padding: 12px;
      }
      i{
        border: 1px solid #36f;
        padding: 1px 5px 0;
        border-radius: 2px;
        font-size: 13px;
        flex: 0 0 auto;
        height: 23px;
      }
      div{
        flex: 1 1 auto;
      }
      span{
        margin-left: 12px;
        display: inline-block;
        // cursor: pointer;
        // &:hover{
        //   text-decoration: underline;
        // }
      }
      p:nth-child(1){
        display: flex;
        width: 100%;
      }
      p:nth-child(2){
        width: 100px;
        text-align: right;
        em{
          color: #eb5b8d;
        }
      }
      em{
        &.hover{
          cursor: pointer;
          &:hover{
            text-decoration: underline;
          }
        }
      }
  }
  .flex-between p{
    display: flex;
    justify-content: space-between;
  }
  .c-trips{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-radius: 0 0 15px 15px;
    margin: 0;
    box-sizing: border-box;
    // border: 2px solid #4E6EF2;
    border-top: none;
    padding: 15px;
    overflow: hidden;
    span{
      font-family: 'JingHuaLaoSongTi'; 
      font-size: 28px;
      display: block;
      flex: 0 0 auto;
      line-height: 30px;
      i{
        padding-left: 5px;
      }
    }
    ul{
      li{
        display: flex;
        font-size: 12px;
        margin: 10px 0;
        i{
          display: inline-block;
          padding: 3px 8px 2px;
          border-radius: 3px;
          margin-right: 8px;
          height: 25px;
          cursor: pointer;
          &:hover{
            text-decoration: underline;
          }
        }
        &:nth-child(1) i{
          border: 1px solid #36f;
          color: #36f;
        }
        &:nth-child(2) i{
          border: 1px solid #eb3333;
          color: #eb3333;
        }
        em{
          font-size: 14px;
        }
      }
    }
  }
}
</style>
<style>
.el-calendar__header{
  display: none!important;
}
.c-body .el-calendar__body{
  padding: 0!important;
}
.c-body .el-calendar-table .el-calendar-day{
  height: 65px;
  font-size: 22px;
  text-align: center;
  box-sizing: border-box;
  overflow: hidden;
}
.c-body .el-calendar-table td.is-selected{
  background: #409eff!important;
  color: #fff;
  border-radius: 5px;
}
.calendar .container .c-body td.is-selected .div-Calendar span.mo,
.calendar .container .c-body td.is-selected .div-Calendar span.red,
.calendar .container .c-body td.is-selected .div-Calendar span.canlendar-jq{
  color: #fff;
}
.c-body .el-calendar-table td.is-selected .el-calendar-day:hover{
  background: #409eff;
  border-radius: 5px;
}
.c-body .el-backtop, .el-calendar-table td.is-today{
  color: #409eff;
  font-weight: 600;
}
.c-body .el-calendar-table .el-calendar-day{
  padding: 0;
}
.c-body .el-calendar-table:not(.is-range) td.next, .el-calendar-table:not(.is-range) td.prev .canlendar-g,
.c-body .el-calendar-table:not(.is-range) td.next, .el-calendar-table:not(.is-range) td.prev .canlendar-n,
.c-body .el-calendar-table:not(.is-range) td.next, .el-calendar-table:not(.is-range) td.prev .canlendar-jq{
 opacity: .6;
}
@media screen and (max-width: 1000px) {
  .calendar{
    display: block!important;
  }
  .calendar .container, .calendar .info, .calendar .info ul li{
    width: 100%!important;
  }
  .calendar .festival-baike p{
    display: none;
  }
  .calendar .container .c-header ol li{
    width: 108px!important;
  }
   .calendar .container .c-header ol li:nth-child(2){
    width: 130px!important;
  }
  .button{
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Dao.vue